// Fetch Haymaker's Beer data from Beermenus
(function(){
  $(document).ready(function() {
    $.getJSON('https://www.beermenus.com/menu_widgets/27162.json', function(results) {
      const drinksListRaw = results.place.servings;
      const lastUpdate = timeConverter(results.place.menu_updated_at);

      // Remove duplicates when there is more than one draft size
      const drinks = [...new Map(drinksListRaw.map(item => [item.beer.name, item])).values()]

      $('#hm-beermenus-timestamp').append(lastUpdate);

      showWebBeers(drinks, "Draft");
      showWebBeers(drinks, "Bottle");
      showWebBeers(drinks, "Can");

      showPrintBeers(drinks, "Draft");
      showPrintBeers(drinks, "Bottle");
      showPrintBeers(drinks, "Can");
    });

    function timeConverter(UNIX_timestamp){
      const timestamp = new Date(UNIX_timestamp * 1000);
      const months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
      const year = timestamp.getFullYear();
      const month = months[timestamp.getMonth()];
      const date = timestamp.getDate();
      return `${month} ${date}, ${year}`;
    }

    function showWebBeers(data, rawCategory) {
      const category = rawCategory.toLowerCase();

      const beerArray = data.map(drink => {
        if (drink.served_in === rawCategory) {
          return `
          <li class="hm-product">
            <div class="product--details">
              <div class="product--details--title-row">
                <div>
                  <h4 class="service-list--block-title-text font--paragraph">
                    ${drink.beer.name}
                  </h4>
                  <span>
                    &mdash; ${drink.beer.style}, ${drink.beer.abv}%
                  </span>
                </div>
              </div>
            </div>
            <div class="hm-collection--product-info font--paragraph">
              ${drink.beer.description}
            </div>
          </li>
        `;
        }
      });

      const beers = beerArray.filter(Boolean);

      let headerTitle = "On Tap";

      if (category !== "draft") {
        headerTitle = `${category}s`;
      }

      if (beers.length >= 1) {
        $(`#hm-beermenus-${category}`).append(
          `
          <h3 class="hm-collection--product-type-header">
            ${headerTitle}
          </h3>
          <ul class="hm-collection--beermenus">
            ${beers.join("")}
          </ul>
        `);
      }
    }

    function showPrintBeers(data, rawCategory) {
      const category = rawCategory.toLowerCase();

      const beerArray = data.map(drink => {
        if (drink.served_in === rawCategory) {
          return `
          <li class="hm-print__item">
            <header class="hm-print__item-header">
              <div>
                <h4 class="hm-print__item-title">
                  ${drink.beer.name}
                </h4>
                <span>
                  &mdash; ${drink.beer.style}, ${drink.beer.abv}%
                </span>
              </div>
              <span class="hm-print__item-price">
                $${parseInt(drink.price).toFixed(0)}
              </span>
            </header>
            <div class="hm-print__item-description">
              ${drink.beer.description}
            </div>
          </li>
        `;
        }
      });

      const beers = beerArray.filter(Boolean);

      let headerTitle = "Draft";
      let divider = "";

      if (category !== "draft") {
        headerTitle = `${category}s`;
        divider = `<hr class="hm-print__divider" />`;
      }

      if (beers.length >= 1) {
        $(`#hm-beermenus-${category}--print`).append(
          `
          ${divider}
          <h3 class="hm-print__secondary-heading">
            ${headerTitle}
          </h3>
          <ul>
            ${beers.join("")}
          </ul>
        `);
      }
    }
  });
})();
